import Chip from '@mui/material/Chip';
import { GettingFileResolutionDto } from 'src/generated/services/TFinancialApi';

interface IResolutionStatusChipProps {
  status: GettingFileResolutionDto['resolutionStatus'];
  size?: 'small' | 'medium';
}

export const ResolutionStatusChip: React.FC<IResolutionStatusChipProps> = ({ status, size = 'medium' }) => {
  let chipStyle = {};
  let label = '';

  if (status === 'FIXED') {
    chipStyle = {
      background: 'rgba(0, 204, 58, 0.20)',
      border: '1px solid #00CC3A',
      borderRadius: '20px',
      color: '#00B233',
    };
    label = 'Fixed';
  } else if (status === 'MISSING_REQUIRED_FIELD') {
    chipStyle = {
      background: '#ffffff',
      border: '1px solid #E72547',
      borderRadius: '20px',
      color: '#E72547',
    };
    label = 'Missing Required Fields';
  } else if (status === 'NOT_AN_INVOICE') {
    chipStyle = {
      background: 'rgba(105, 123, 212, 0.12)',
      border: '1px solid #697BD4',
      borderRadius: '20px',
      color: '#697BD4',
    };
    label = 'Invalid File';
  } else if (status === 'REVIEW_REQUIRED') {
    chipStyle = {
      background: 'rgba(231, 37, 71, 0.20)',
      border: '1px solid #E72547',
      borderRadius: '20px',
      color: '#E72547',
    };
    label = 'Review Required';
  } else if (status === 'UNDER_REVIEW') {
    chipStyle = {
      background: 'rgba(247, 152, 36, 0.2)',
      border: '1px solid #F79824',
      borderRadius: '20px',
      color: '#E58D21',
    };
    label = 'Under Review';
  } else if (status === 'INCONSISTENT_SHIPMENT_DATA') {
    chipStyle = {
      background: 'rgba(255, 255, 255, 1)',
      border: '1px solid #F79824',
      borderRadius: '20px',
      color: '#F79824',
    };
    label = 'Inconsistent Shipment Data';
  }
  return <Chip label={label} style={chipStyle} size={size} />;
};
